import React, {Component} from "react";
import {Button} from "primereact/button";
import {Growl} from 'primereact/growl';
import ConfirmationMessage from "../../../components/confirmationMessage"
import {CapacityTableService} from "../../../service/limitControl/CapacityTableService";
import {CloseSystemService} from "../../../service/support/CloseSystemService";
import CapacityTableView from "./CapacityTableView";

export default class CapacityTableContainer extends Component {
    constructor(props) {
        super(props);
        this.capacityTableService = new CapacityTableService();
        this.closeSystemService = new CloseSystemService();
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        this.state = {
            isClosed: false,
            displayInfoDialog: false,
            dataCapacityTable: [],
            borrowerInstitutions: [],
            selectedRows: [],
            minimumCapacity : 0,
            rowSelected: {},
            isLoading: true,
            isEditMinimumCapacity: false,
            isAddException: false,
            isEditException: false,
            changeData: {
                borrower: {},
                deleteExceptions: false,
                lenderShortName: "lenderShortName",
                lenderId: "",
                borrowerShortName: "borrowerShortName",
                borrowerId: "",
                percentageCapacity: ""
            }
        };

        this.getDataCapacityTable = this.getDataCapacityTable.bind(this);
        this.getBorrowerInstitutions = this.getBorrowerInstitutions.bind(this);
        this.capacityTableActionTemplate = this.capacityTableActionTemplate.bind(this);
        this.handleSelectedRows = this.handleSelectedRows.bind(this);
        this.getDialogHeaderMinimumCapacity = this.getDialogHeaderMinimumCapacity.bind(this);
        this.getDialogHeaderException = this.getDialogHeaderException.bind(this);
        this.openDialogMinimumCapacity = this.openDialogMinimumCapacity.bind(this);
        this.openDialogAddException = this.openDialogAddException.bind(this);
        this.openDialogEditException = this.openDialogEditException.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.onHideInfoDialog = this.onHideInfoDialog.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
        this.onChangeInputText = this.onChangeInputText.bind(this);
        this.onChangeDrop = this.onChangeDrop.bind(this);
        this.onChangeCheckBox = this.onChangeCheckBox.bind(this);
        this.showMessage = this.showMessage.bind(this);
        this.editMinimumCapacity = this.editMinimumCapacity.bind(this);
        this.updateException = this.updateException.bind(this);
        this.deleteExceptions = this.deleteExceptions.bind(this);
        this.validPercentage = this.validPercentage.bind(this);
        this.validBorrower = this.validBorrower.bind(this);
        this.loading = this.loading.bind(this);
        this.openConfMsg = this.openConfMsg.bind(this);
        this.validateIfIsCloseSystem = this.validateIfIsCloseSystem.bind(this);
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    componentDidMount() {
        this.getDataCapacityTable();
        this.validateIfIsCloseSystem();
    }

    validateIfIsCloseSystem() {
        this.loading(true);
        this.closeSystemService.isCloseSystem().then(data => {
            let isClosedAux = data.closed === undefined ? false : Boolean(data.closed);
            this.setState({
                isClosed: !isClosedAux,
                displayInfoDialog: !isClosedAux
            });
        });
    }

    getDataCapacityTable() {
        this.loading(true);
        this.capacityTableService.getCapacityTableData().then(data => {
            if(data === undefined || data.message !== "Success") {
                this.growl.show({severity: 'info', summary: 'Info.',
                    detail: "No hay datos"});
            } else {
                let dataTable = data.payload[0];
                this.setState({
                    dataCapacityTable: dataTable.minimumCapacityPerInstitutionDtoList,
                    minimumCapacity: dataTable.minimumCapacity
                });
            }
            this.loading(false);
        }).catch(error =>
            this.growl.show({severity: 'info', summary: 'Info.',
                detail: "No hay datos"})
        );
    }

    getBorrowerInstitutions() {
        this.loading(true);
        this.capacityTableService.getBorrowerInstitutions().then(data => {
            if(data === undefined || data.message !== "Success") {
                this.growl.show({severity: 'info', summary: 'Info.',
                    detail: "No hay instituciones para operar"});
            } else {
                this.setState({
                    borrowerInstitutions: data.payload,
                });
            }
            this.loading(false);
        }).catch(error =>
            this.growl.show({severity: 'info', summary: 'Info.',
            detail: "No hay instituciones para operar"}));
    }

    onHideDialog() {
        this.loading(false);
        this.setState({
            displayDialog: false,
            isEditMinimumCapacity: false,
            isAddException: false,
            isEditException: false,
            changeData: {
                deleteExceptions: false,
                lenderShortName: "",
                lenderId: "",
                borrowerShortName: "",
                borrowerId: "",
                percentageCapacity: "",
                borrower: {}
            },
            selectedRows: [],
        })
    }
    onHideInfoDialog() {
        this.loading(false);
        this.setState({
            displayInfoDialog: false,
        });
    }

    capacityTableActionTemplate(rowData, column) {
        let dataSelected = JSON.parse(JSON.stringify(rowData));
        return (
            <Button type="button"
                    label="Editar"
                    disabled={this.isClose}
                    onClick={() => this.openDialogEditException(dataSelected)}/>
        );
    }

    getDialogHeaderMinimumCapacity(){
        return (
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-8" style={{padding: '.1em'}}>
                    <h2 className={"secondary-text"}>Editar Aforo Mínimo Requerido</h2>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.2em'}}>
                    <Button label="Regresar"
                            onClick={this.onHideDialog}
                            className="p-button-secondary"/>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.2em'}}>
                    <Button label="Guardar"
                            onClick={this.editMinimumCapacity}/>
                </div>
            </div>
        );
    }

    getDialogHeaderException(isAdd){
        return (
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-8" style={{padding: '.1em'}}>
                    <h2 className={"secondary-text"} hidden={!isAdd}>Agregar Excepción</h2>
                    <h2 className={"secondary-text"} hidden={isAdd}>Editar Excepción</h2>

                </div>
                <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.2em'}}>
                    <Button label="Regresar"
                            onClick={this.onHideDialog}
                            className="p-button-secondary"/>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.2em'}}>
                    <Button label="Guardar"
                            onClick={this.updateException}/>
                </div>
            </div>
        );
    }

    openDialogMinimumCapacity(){
        let dialogHeader = this.getDialogHeaderMinimumCapacity();
        let changeData = this.state.changeData;
        changeData.percentageCapacity = this.state.minimumCapacity * 100;
        changeData.deleteExceptions = false;
        this.setState({
            dialogHeader: dialogHeader,
            changeData: changeData,
            isEditMinimumCapacity: true,
            displayDialog: true,
        })
    }
    openDialogAddException(){
        let dialogHeader = this.getDialogHeaderException(true);
        this.getBorrowerInstitutions();
        let changeData = this.state.changeData;
        changeData.lenderShortName = localStorage.getItem('institution');
        changeData.lenderId = localStorage.getItem('institutionId');
        changeData.borrowerShortName = "";
        changeData.borrowerId = "";
        changeData.percentageCapacity = "";
        changeData.deleteExceptions = false;
        this.setState({
            dialogHeader: dialogHeader,
            changeData: changeData,
            isAddException: true,
            deleteExceptions: false,
            displayDialog: true,
        })
    }

    openDialogEditException(rowData) {
        let dialogHeader = this.getDialogHeaderException(false);
        let changeData = rowData;
        changeData.percentageCapacity = rowData.minimumCapacity * 100;
        this.setState({
            dialogHeader: dialogHeader,
            changeData: changeData,
            displayDialog: true,
            deleteExceptions: false,
            isEditException: true,
        });
    }

    handleSelectedRows = (event) => {
        this.setState({selectedRows: event.value,})
    };

    onChangeInputText(event) {
        const {name, value} = event.target;
        let changeDataAux = this.state.changeData;
        changeDataAux[name] = value;
        this.setState({changeData: changeDataAux,})
    }

    onChangeDrop(event) {
        const {value} = event.target;
        let changeDataAux = this.state.changeData;
        changeDataAux.borrower = value;
        changeDataAux.borrowerId = value.institutionId;
        changeDataAux.borrowerShortName = value.shortName;
        this.setState({changeData: changeDataAux,})
    }
    onChangeCheckBox(event) {
        const {name} = event.target;
        let changeDataAux = this.state.changeData;
        changeDataAux[name] = event.checked;
        this.setState({changeData: changeDataAux,})
    }

    onChangeValue(event) {
        const {name, value} = event.target;
        let rowSelectedAux = this.state.rowSelected;
        rowSelectedAux[name] = value;
        this.setState({rowSelected: rowSelectedAux,})
    }

    editMinimumCapacity(){
        if(this.validPercentage()){
            let isSuccessed = false;
            let params = {
                minimumCapacity: this.state.changeData.percentageCapacity,
                deleteExceptions: this.state.changeData.deleteExceptions
            }
            this.capacityTableService.editMinimumCapacity(params).then(data => {
                isSuccessed = data !== undefined && data.message === "Success";
                this.loading(false);
                this.showMessage(isSuccessed);
                this.getDataCapacityTable();
            }).catch(error =>
                this.showMessage(false));
        } else {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Error, información no válida'
            });
        }
    }

    updateException(){
        if(this.validPercentage() && this.validBorrower()){
            let params = {
                borrowerId: this.state.changeData.borrowerId,
                minimumCapacity: this.state.changeData.percentageCapacity,
            }
            this.capacityTableService.updateException(params).then(data => {
                this.showMessage(data !== undefined && data.message === "Success");
                this.loading(false);
                this.getDataCapacityTable();
            }).catch(error =>
                this.showMessage(false));
        } else {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Error, información no válida'
            });
        }
    }

    deleteExceptions() {
        let selectedRows = this.state.selectedRows;
        if(selectedRows === undefined || selectedRows.length === 0) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'No hay filas seleccionadas.'
            });
        } else {

            selectedRows.forEach((item)=>{
                this.capacityTableService.deleteException(item.borrowerId).then(data => {
                    if (data === undefined || data.message !== "Success") {
                        this.growl.show({
                            severity: 'error', summary: 'Error.',
                            detail: 'Error al borrar' + item.borrowerShortName
                        });
                    }
                    this.loading(false);
                    this.getDataCapacityTable();
                }).catch(error =>
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: 'Error al borrar' + item.borrowerShortName
                    }));
            });
            this.growl.show({
                severity: 'success', summary: 'Éxito.',
                detail: 'Excepciones eliminadas'
            });
        }
    }

    showMessage(successed){
        if(successed){
            this.growl.show({severity: 'success', summary: 'Éxito.',
                detail: 'Información guardada exitosamente.'});
        } else {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Error al Guardar'
            });
        }
        this.onHideDialog();
    }

    validPercentage(){
        let nonEmpty = ! (this.state.changeData.percentageCapacity === undefined
            || this.state.changeData.percentageCapacity === "");
        let validValue = this.state.changeData.percentageCapacity < 100;
        return nonEmpty && validValue;
    }

    validBorrower(){
        return ! (this.state.changeData.borrowerId === undefined
            || this.state.changeData.borrowerId === "");
    }
    openConfMsg() {
        if (this.confirmationRef) {
            this.confirmationRef.openConfirmationMessage();
        }
    }


    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Está seguro que desea eliminar las excepciones?"
                                           action={this.deleteExceptions}/>;
        return <CapacityTableView dataCapacityTable={this.state.dataCapacityTable}
                                  borrowerInstitutions={this.state.borrowerInstitutions}
                                  displayDialog={this.state.displayDialog}
                                  isLoading={this.state.isLoading}
                                  selectedRows={this.state.selectedRows}
                                  listAforos={this.state.listAforos}
                                  minimumCapacity={this.state.minimumCapacity}
                                  dialogHeader={this.state.dialogHeader}
                                  isEditMinimumCapacity={this.state.isEditMinimumCapacity}
                                  changeData={this.state.changeData}
                                  isAddException={this.state.isAddException}
                                  isEditException={this.state.isEditException}
                                  messagesGrowl={messagesGrowl}
                                  confirmationMessage={confMsg}
                                  getDataCapacityTable={this.getDataCapacityTable}
                                  onHideDialog={this.onHideDialog}
                                  capacityTableActionTemplate={this.capacityTableActionTemplate}
                                  onChangeValue={this.onChangeValue}
                                  handleSelectedRows={this.handleSelectedRows}
                                  openDialogMinimumCapacity={this.openDialogMinimumCapacity}
                                  openDialogAddException={this.openDialogAddException}
                                  onChangeInputText ={this.onChangeInputText}
                                  onChangeDrop={this.onChangeDrop}
                                  onChangeCheckBox={this.onChangeCheckBox}
                                  openConfMsg={this.openConfMsg}
                                  onHideInfoDialog={this.onHideInfoDialog}
                                  isClosed={this.state.isClosed}
                                  displayInfoDialog={this.state.displayInfoDialog}

        />
    }
};